import React from "react";
import { Button, Space, Tag, Tooltip } from "antd";
import { EyeOutlined, EditOutlined, DeleteOutlined, PoweroffOutlined } from "@ant-design/icons";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

const SortableTrainingComponentRow = ({
  item,
  loading,
  updatingStatus,
  searchTerm,
  formatDate,
  handleToggleActive,
  openViewModal,
  openEditModal,
  openDeleteModal,
  isDragging = false,
  isOverlay = false,
  isDragEnabled = true,
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging: isSortableDragging,
  } = useSortable({
    id: item.id,
    disabled: !isDragEnabled,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isSortableDragging ? 0.5 : 1,
    backgroundColor: isSortableDragging ? "#f0f7ff" : "transparent",
    ...(isOverlay && {
      opacity: 0.9,
      backgroundColor: "#f8f9fa",
    }),
  };

  const dragHandleProps = isDragEnabled ? { ...attributes, ...listeners } : {};

  return (
    <tr
      ref={setNodeRef}
      style={style}
      className={isDragging ? "dragging-row" : ""}
    >
      {/* ✅ SIRF DRAG HANDLE COLUMN - # COLUMN HATAYA */}
      <td style={{ width: "40px", textAlign: "center" }}>
        {isDragEnabled && (
          <span
            {...dragHandleProps}
            style={{
              cursor: "grab",
              fontSize: "18px",
              color: "#666",
              display: "inline-block",
              padding: "4px",
            }}
            title="Drag to reorder"
          >
            ⋮⋮
          </span>
        )}
      </td>

      {/* Name */}
      <td>
        {item.name || "N/A"}
        {item.display_order === 0 && !searchTerm && isDragEnabled && (
          <span className="top-badge"></span>
        )}
      </td>

      {/* Description */}
      <td className="description-cell">
        {item.description && item.description.length > 50
          ? `${item.description.substring(0, 50)}...`
          : item.description || "N/A"}
      </td>

      {/* Created At */}
      <td>{formatDate(item.created_at)}</td>

      {/* Updated At */}
      <td>{formatDate(item.updated_at)}</td>

      {/* Status */}
      <td>
        <Tag color={item.is_active ? "green" : "default"}>{item.is_active ? "Active" : "Inactive"}</Tag>
      </td>

      {/* Actions */}
      <td>
        <Space size="small">
          <Tooltip title={item.is_active ? "Deactivate" : "Activate"}>
            <Button className="btn-toggle-active"  danger={!!item.is_active} type={item.is_active ? "default" : "primary"} icon={<PoweroffOutlined />} onClick={() => handleToggleActive(item)} disabled={loading || updatingStatus} />
          </Tooltip>
          <Tooltip title="View">
            <Button className="btn-view" type="primary"  icon={<EyeOutlined />} onClick={() => openViewModal(item)} disabled={loading} />
          </Tooltip>
          <Tooltip title="Edit">
            <Button className="btn-edit" type="primary"  style={{ background: "#52c41a", borderColor: "#52c41a" }} icon={<EditOutlined />} onClick={() => openEditModal(item)} disabled={loading} />
          </Tooltip>
          <Tooltip title="Delete">
            <Button className="btn-delete" danger  icon={<DeleteOutlined />} onClick={() => openDeleteModal(item)} disabled={loading} />
          </Tooltip>
        </Space>
      </td>
    </tr>
  );
};

export default SortableTrainingComponentRow;
